import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
import { TextInput } from 'SRC/ui/FormElements'
import { priceMask } from 'Core/masks'

class PriceDaily extends React.Component {
  componentDidUpdate () {
    const { priceDailyMasked } = this.props
    this.props.change(this.props.formName, 'priceDailyUnmasked', priceDailyMasked.toString().replace(',', '.'))
  }

  shouldComponentUpdate (nextProps) {
    return nextProps.priceDailyMasked && this.props.priceDailyMasked !== nextProps.priceDailyMasked
  }
  render () {
    return [<TextInput
      id='priceDaily'
      label='Dnevno'
      name='priceDaily'
      measure='€'
      mask={priceMask}
    />, <input id='priceDailyUnmaksed' type='hidden' name='priceDailyUnmaksed' />]
  }
}

const mapStateToProps = (state, ownProps) => {
  const selector = formValueSelector(ownProps.formName)
  return {
    priceDailyMasked: selector(state, 'priceDaily')
  }
}

PriceDaily.propTypes = {
  priceDailyMasked: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired
}

PriceDaily.defaultProps = {
  priceDailyMasked: ''
}

export default connect(mapStateToProps, {change})(PriceDaily)
